module.exports = __webpack_public_path__ + "static/media/fredrik.b8160576.jpeg";